import React, { useState, useEffect } from 'react';
import {
  StackLayout,
  GDSStyleObject,
  Box,
  Card,
} from '@leagueplatform/genesis-core';

import {
  AppEnvironment,
  ENVIRONMENT,
  useConfigProperty,
} from '@leagueplatform/core';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import {
  getAccessToken,
  getClientAccessToken,
  getPartnerToken,
} from '../common/helpers';
import { accountManagementLibrary } from '../account-management.config';
import { PageHeader } from './pages/page-header.component';
import { AccountManagementComponent } from './pages/sidebar/account-management.component';
import { TobaccoModal } from './pages/tobacco-modal.page';
import { MFA_ROUTES, TD_ROUTES } from '../common/constant';
import { HIGHMARK_APP_TYPE } from '../common/types';

export function AccountManagementPage() {
  const tenantId = useConfigProperty('core.tenantId');
  const [showModal, setShowModal] = useState(false);
  const [showCImodal, setShowCImodal] = useState(false);
  const [showCPmodal, setShowCPmodal] = useState(false);
  const [showPCPmodal, setShowPCPmodal] = useState(false);
  const [plans, setPlans] = useState({});
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [plansLoading, setPlansLoading] = useState(false);
  const [partnerToken, setPartnerToken] = useState<string | null>(null);
  const [baseURLMFA, setBaseURLMFA] = useState('');
  const [baseURLTD, setBaseURLTD] = useState('');
  const navigate = useNavigate();
  const config = accountManagementLibrary.getConfig();

  const highmarkURL = config.HIGHMARK_API_URL;

  const { useCurrentRegionUbkHeader } = config;

  const currentUbk: any = useCurrentRegionUbkHeader() || null;

  const ubkValue = currentUbk?.headers?.Brandubk || null;

  const [showError, setShowError] = useState(false);

  const [demographics, setDemographics] = useState({});

  const segment = window.location.href.substring(
    window.location.href.lastIndexOf('/') + 1,
  );

  const getIdentityToken = async () => {
    if (!partnerToken) {
      const response = await getPartnerToken();
      if (response) {
        if (response.token) {
          setPartnerToken(response?.token);
          return;
        }
        if (response.errMsg) {
          setPartnerToken(null);
          setShowError(true);
        }
      }
    }
  };

  // useEffect(() => {
  //   setIsLoading(true);
  //   getAccessToken(
  //     `${highmarkURL}/digital/v1/members/demographics/profile`,
  //     '',
  //     ubkValue,
  //   ).then((result: any) => {
  //     setIsLoading(false);
  //     if (!result?.errMsg) {
  //       setDemographics(result.demographics);
  //     }
  //     // else {
  //     //   // setShowError(true);
  //     // }
  //   });
  // }, [highmarkURL, ubkValue]);

  useEffect(() => {
    getIdentityToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIsLoading(true);
    setPlansLoading(true);

    if (partnerToken) {
      getAccessToken(
        `${highmarkURL}/digital/v1/members/demographics/profile`,
        partnerToken,
        '',
        ubkValue,
      ).then((result: any) => {
        setIsLoading(false);
        if (!result?.errMsg) {
          setDemographics(result.demographics);
        }
      });

      getAccessToken(
        `${highmarkURL}/digital/v1/members/benefits/plans?planYear=all`,
        partnerToken,
        '',
        ubkValue,
      ).then((result: any) => {
        if (!result?.errMsg) {
          const res = result?.plans;
          setPlans(res);
          getAccessToken(
            `${highmarkURL}/digital/v1/members/health/services`,
            partnerToken,
            '',
            ubkValue,
          ).then((result2: any) => {
            if (!result2?.errMsg) {
              const data = result2.services;
              setServices(data);
              setPlansLoading(false);
              if (
                segment === 'contact-information' ||
                window.location.pathname ===
                  '/account-management/contact-information'
              ) {
                setShowCImodal(true);
              } else if (
                segment === 'communication-preferences' ||
                window.location.pathname ===
                  '/account-management/communication-preferences'
              ) {
                setShowCPmodal(true);
              } else if (
                segment === 'primary-care' ||
                window.location.pathname === '/account-management/primary-care'
              ) {
                setShowPCPmodal(true);
              }
            } else {
              setPlansLoading(false);
              // setShowError(true);
            }
          });
        } else {
          // setShowError(true);
          setPlansLoading(false);
        }
      });
    }
  }, [highmarkURL, partnerToken, segment, ubkValue]);

  useEffect(() => {
    const handlePopState = () => {
      navigate(-1);
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [navigate]);

  useEffect(() => {
    async function fetchData() {
      if (partnerToken) {
        let baseUrlMFA;
        let baseUrlTD;
        if (AppEnvironment.environment === ENVIRONMENT.PRODUCTION) {
          baseUrlMFA = MFA_ROUTES.PRODUCTION_URL;
          baseUrlTD = TD_ROUTES.PRODUCTION_URL;
          if (tenantId === HIGHMARK_APP_TYPE.AMH) {
            baseUrlMFA = MFA_ROUTES.PRODUCTION_URL_AMH;
            baseUrlTD = TD_ROUTES.PRODUCTION_URL_AMH;
          }
        } else {
          baseUrlMFA = MFA_ROUTES.TEST_URL;
          baseUrlTD = TD_ROUTES.TEST_URL;
          if (tenantId === HIGHMARK_APP_TYPE.AMH) {
            baseUrlMFA = MFA_ROUTES.TEST_URL_AMH;
            baseUrlTD = TD_ROUTES.TEST_URL_AMH;
          }
        }
        const decryURL = getClientAccessToken(baseUrlMFA, partnerToken);
        const decryURL2 = getClientAccessToken(baseUrlTD, partnerToken);
        setBaseURLMFA(await decryURL);
        setBaseURLTD(await decryURL2);
      }
    }
    fetchData();
  }, [tenantId, partnerToken]);

  return (
    <Box
      css={
        {
          backgroundColor: '#ffffff',
          minHeight: '100vh',
        } as GDSStyleObject
      }
    >
      <PageHeader showBackButton={false} />
      <Card.Section>
        <Box
          css={
            {
              boxSizing: 'border-box',
              margin: '0px auto',
              width: '100%',
              maxWidth: '1132px',
            } as GDSStyleObject
          }
        >
          <StackLayout
            orientation="horizontal"
            spacing={{ '@desktop': '$two' }}
            css={{ display: 'block' }}
          >
            {!isLoading && !plansLoading && (
              <>
                <AccountManagementComponent
                  setShowModal={setShowModal}
                  showModal={showModal}
                  plans={plans}
                  baseURLMFA={baseURLMFA}
                  baseURLTD={baseURLTD}
                  showCImodal={showCImodal}
                  showCPmodal={showCPmodal}
                  showPCPmodal={showPCPmodal}
                  setShowCImodal={setShowCImodal}
                  setShowCPmodal={setShowCPmodal}
                  setShowPCPmodal={setShowPCPmodal}
                  services={services}
                  ubkValue={ubkValue}
                  tenantId={tenantId}
                />
                <TobaccoModal
                  setShowModal={setShowModal}
                  showModal={showModal}
                  plans={plans}
                  showError={showError}
                  setShowError={setShowError}
                  demographics={demographics}
                  ubkValue={ubkValue}
                />
              </>
            )}
            {(isLoading || plansLoading) && <LoadingIndicator />}
          </StackLayout>
        </Box>
      </Card.Section>
    </Box>
  );
}
